/**
 * @file reducers/Loader/reducer.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { ZERO_COUNT } from "./constants";

const initialLoaderState = () => {
    return {
        loaded: true,
        count: 0,
    };
};

const loaderSlice = createSlice({
    name: "loader",
    initialState: initialLoaderState(),
    reducers: {
        start_loading: (state) => {
            return {
                ...state,
                count: isNaN(state.count) ? 1 : state.count + 1,
                loaded: false,
            };
        },
        loading_complete: (state) => {
            const newCount = state.count - 1;
            const isLoaded = newCount === ZERO_COUNT ? true : false;
            return {
                ...state,
                count: newCount,
                loaded: isLoaded,
            };
        },
    },
});

export const { start_loading, loading_complete } = loaderSlice.actions;

export default loaderSlice.reducer;
